import OkC from "shared/util/OkcApi";

export default {
	getShouldShowCaptcha() {
		return OkC.get("/signup/should_show_captcha", { api: 1 });
	},

	submitRegistration({ email, password, captcha, tspRefreshToken }) {
		const data = {
			email,
			password,
		};

		if (captcha) {
			data.recaptcha_response = captcha;
		}

		if (tspRefreshToken) {
			data.tsp_refresh_token = tspRefreshToken;
		}

		return OkC.post("/signup/email", { api: 1, data });
	},

	recordStartOnboarding() {
		return OkC.post("/signup/start", {
			api: 1,
		});
	},
};



// WEBPACK FOOTER //
// ./src/apps/signup/util/web.js